import { hasAnyPermission, hasPermission, isSuperAdminUser } from '../utils/permissions';

export const SETTINGS_TOPICS = [
  {
    id: 'products',
    label: 'Productos',
    description: 'Catalogo, formatos y barcodes.',
    sections: [
      {
        id: 'catalog-categories',
        group: 'Categorias',
        label: 'Categorias',
        description: 'Disponibilidad por caja.',
        branchScoped: true,
      },
      {
        id: 'catalog-subcategories',
        group: 'Categorias',
        label: 'Sub categorias',
        description: 'Agrupaciones internas.',
        branchScoped: true,
      },
      {
        id: 'catalog-category-barcodes',
        group: 'Categorias',
        label: 'Codigo de barras categorias',
        description: 'Identificadores por categoria.',
        branchScoped: false,
        productConfiguration: true,
      },
      {
        id: 'catalog-products',
        group: 'Productos',
        label: 'Productos',
        description: 'Productos y variedades.',
        branchScoped: true,
      },
      {
        id: 'catalog-product-formats',
        group: 'Productos',
        label: 'Formatos de producto',
        description: 'Formatos compartidos.',
        branchScoped: false,
        productConfiguration: true,
      },
      {
        id: 'catalog-format-equivalences',
        group: 'Productos',
        label: 'Equivalencias de formatos',
        description: 'Conversiones para inventario.',
        branchScoped: true,
        productConfiguration: true,
      },
      {
        id: 'catalog-product-barcodes',
        group: 'Productos',
        label: 'Codigo de barra productos',
        description: 'Prefijos de codigos.',
        branchScoped: false,
        productConfiguration: true,
      },
      {
        id: 'catalog-product-search',
        group: 'Productos',
        label: 'Busqueda de productos',
        description: 'Modo global de busqueda.',
        branchScoped: false,
        productConfiguration: true,
      },
      {
        id: 'catalog-pos-sales',
        group: 'Productos',
        label: 'Venta POS',
        description: 'Visualizacion compartida.',
        branchScoped: false,
        productConfiguration: true,
      },
    ],
  },
  {
    id: 'prices',
    label: 'Precios',
    description: 'Precios, descuentos e impuestos.',
    sections: [
      {
        id: 'catalog-price-list',
        label: 'Configuración de precios',
        description: 'Costos y reglas por formato.',
        branchScoped: true,
      },
      {
        id: 'sale-rounding',
        label: 'Redondeo de ventas',
        description: 'Descuento automático sobre el total final.',
        branchScoped: true,
      },
      {
        id: 'complex-price-rules',
        label: 'Reglas complejas por costo',
        description: 'Rangos reutilizables de margen según costo.',
        branchScoped: false,
      },
      {
        id: 'client-pricing-categories',
        label: 'Categorias de descuento por cliente',
        description: 'Descuentos por formato.',
        branchScoped: true,
      },
      {
        id: 'client-pricing-configuration',
        label: 'Configuracion de precios por cliente',
        description: 'Modo de edicion de categorias.',
        branchScoped: false,
        productConfiguration: true,
      },
      {
        id: 'catalog-price-recommendations',
        label: 'Recomendaciones de precios',
        description: 'Reglas desde compras.',
        branchScoped: true,
        productConfiguration: true,
      },
      {
        id: 'branch-price-sync',
        label: 'Sincronizacion de precios entre sucursales',
        description: 'Casa matriz y ajuste.',
        branchScoped: true,
        productConfiguration: true,
      },
      {
        id: 'taxes-manage',
        label: 'Impuestos y activacion por sucursal',
        description: 'Definiciones y activacion.',
        branchScoped: false,
        productConfiguration: true,
      },
      {
        id: 'price-auto-rule',
        label: 'Selección automática de formato',
        description: 'Umbrales globales para cambiar formato en ventas.',
        branchScoped: false,
        productConfiguration: true,
      },
    ],
  },
  {
    id: 'users-access',
    label: 'Usuarios y accesos',
    description: 'Usuarios, roles y permisos.',
    sections: [
      {
        id: 'users-access',
        label: 'Usuarios',
        description: 'Roles, sucursales y cajas.',
        branchScoped: false,
      },
    ],
  },
  {
    id: 'branches',
    label: 'Sucursales',
    description: 'Estructura y operacion.',
    sections: [
      {
        id: 'branch-directory',
        group: 'Sucursales',
        label: 'Sucursales y cajas',
        description: 'Datos, usuarios, accesos y cajas.',
        branchScoped: false,
      },
      {
        id: 'branch-stock-requests',
        group: 'Sucursales',
        label: 'Configuracion de solicitudes de stock',
        description: 'Sucursal principal.',
        branchScoped: false,
        productConfiguration: true,
      },
    ],
  },
  {
    id: 'purchase-orders',
    label: 'Ordenes de compra',
    description: 'Revision, motivos y portal.',
    sections: [
      {
        id: 'purchase-order-review',
        label: 'Revision de ordenes de compra',
        description: 'Como procesas items.',
        branchScoped: false,
        productConfiguration: true,
      },
      {
        id: 'purchase-order-reasons',
        label: 'Motivos de cambios en ordenes',
        description: 'Opciones para ajustes.',
        branchScoped: false,
        productConfiguration: true,
      },
      {
        id: 'purchase-order-visible-formats',
        label: 'Formatos visibles para ordenes',
        description: 'Formatos del portal.',
        branchScoped: false,
        productConfiguration: true,
      },
      {
        id: 'purchase-order-default-categories',
        label: 'Categorias por defecto de ordenes',
        description: 'Categorias iniciales del portal.',
        branchScoped: false,
        productConfiguration: true,
      },
    ],
  },
  {
    id: 'notifications',
    label: 'Notificaciones',
    description: 'Avisos y navegador.',
    sections: [
      {
        id: 'notifications',
        label: 'Notificaciones',
        description: 'Roles y avisos push.',
        branchScoped: false,
        productConfiguration: true,
      },
    ],
  },
  {
    id: 'workspace',
    label: 'Mi entorno',
    description: 'Preferencias personales.',
    sections: [
      {
        id: 'registers-printing',
        group: 'Impresion',
        label: 'Impresion personal',
        description: 'Recibos en este navegador.',
        branchScoped: false,
        productConfiguration: true,
      },
      {
        id: 'registers-print-defaults',
        group: 'Impresion',
        label: 'Impresion global',
        description: 'Valores por defecto.',
        branchScoped: false,
        productConfiguration: true,
      },
      {
        id: 'registers-pos-favs',
        group: 'POS',
        label: 'Favs POS',
        description: 'Tus atajos por caja.',
        branchScoped: true,
        productConfiguration: true,
      },
    ],
  },
  {
    id: 'platform-administration',
    label: 'Administración de plataforma',
    description: 'Empresas y entornos de la plataforma.',
    collapsible: true,
    sections: [
      {
        id: 'companies',
        label: 'Empresas',
        description: 'Ciclo de vida y aprovisionamiento.',
        branchScoped: false,
      },
    ],
  },
];

export const SETTINGS_SECTION_SCOPES = {
  'sale-rounding': {
    label: 'Empresa + sucursal',
    className: 'border-indigo-100 bg-indigo-50 text-indigo-700',
  },
  companies: {
    label: 'Plataforma',
    className: 'border-purple-100 bg-purple-50 text-purple-700',
  },
  'registers-printing': {
    label: 'Usuario / navegador',
    className: 'border-emerald-100 bg-emerald-50 text-emerald-700',
  },
  'purchase-order-review': {
    label: 'Usuario',
    className: 'border-emerald-100 bg-emerald-50 text-emerald-700',
  },
  'registers-pos-favs': {
    label: 'Usuario + caja',
    className: 'border-emerald-100 bg-emerald-50 text-emerald-700',
  },
  'branch-directory': {
    label: 'Global',
    className: 'border-indigo-100 bg-indigo-50 text-indigo-700',
  },
  'users-access': {
    label: 'Global + sucursal',
    className: 'border-indigo-100 bg-indigo-50 text-indigo-700',
  },
  'catalog-product-formats': {
    label: 'Global',
    className: 'border-indigo-100 bg-indigo-50 text-indigo-700',
  },
  'catalog-format-equivalences': {
    label: 'Sucursal + global',
    className: 'border-blue-100 bg-blue-50 text-blue-700',
  },
  'catalog-product-barcodes': {
    label: 'Usuario / navegador',
    className: 'border-emerald-100 bg-emerald-50 text-emerald-700',
  },
  'catalog-category-barcodes': {
    label: 'Global',
    className: 'border-indigo-100 bg-indigo-50 text-indigo-700',
  },
  'catalog-subcategories': {
    label: 'Global + sucursal',
    className: 'border-blue-100 bg-blue-50 text-blue-700',
  },
  'taxes-manage': {
    label: 'Global + sucursal',
    className: 'border-indigo-100 bg-indigo-50 text-indigo-700',
  },
  'catalog-product-search': {
    label: 'Global',
    className: 'border-indigo-100 bg-indigo-50 text-indigo-700',
  },
  'catalog-pos-sales': {
    label: 'Global',
    className: 'border-indigo-100 bg-indigo-50 text-indigo-700',
  },
  'registers-barcode': {
    label: 'Global',
    className: 'border-indigo-100 bg-indigo-50 text-indigo-700',
  },
  'registers-print-defaults': {
    label: 'Global',
    className: 'border-indigo-100 bg-indigo-50 text-indigo-700',
  },
  'purchase-order-reasons': {
    label: 'Global',
    className: 'border-indigo-100 bg-indigo-50 text-indigo-700',
  },
  'purchase-order-notifications': {
    label: 'Global + navegador',
    className: 'border-indigo-100 bg-indigo-50 text-indigo-700',
  },
  notifications: {
    label: 'Global + navegador',
    className: 'border-indigo-100 bg-indigo-50 text-indigo-700',
  },
  'purchase-order-visible-formats': {
    label: 'Global',
    className: 'border-indigo-100 bg-indigo-50 text-indigo-700',
  },
  'purchase-order-default-categories': {
    label: 'Global',
    className: 'border-indigo-100 bg-indigo-50 text-indigo-700',
  },
  'branch-stock-requests': {
    label: 'Global + sucursal',
    className: 'border-indigo-100 bg-indigo-50 text-indigo-700',
  },
  'price-auto-rule': {
    label: 'Global',
    className: 'border-indigo-100 bg-indigo-50 text-indigo-700',
  },
  'registers-cash': {
    label: 'Sucursal',
    className: 'border-blue-100 bg-blue-50 text-blue-700',
  },
  'catalog-categories': {
    label: 'Global + sucursal',
    className: 'border-blue-100 bg-blue-50 text-blue-700',
  },
  'catalog-products': {
    label: 'Sucursal',
    className: 'border-blue-100 bg-blue-50 text-blue-700',
  },
  'catalog-price-list': {
    label: 'Empresa + sucursal',
    className: 'border-indigo-100 bg-indigo-50 text-indigo-700',
  },
  'complex-price-rules': {
    label: 'Empresa',
    className: 'border-indigo-100 bg-indigo-50 text-indigo-700',
  },
  'catalog-price-recommendations': {
    label: 'Sucursal',
    className: 'border-blue-100 bg-blue-50 text-blue-700',
  },
  'branch-price-sync': {
    label: 'Sucursal + global',
    className: 'border-blue-100 bg-blue-50 text-blue-700',
  },
  'client-pricing-categories': {
    label: 'Global + sucursal',
    className: 'border-blue-100 bg-blue-50 text-blue-700',
  },
  'client-pricing-configuration': {
    label: 'Global',
    className: 'border-indigo-100 bg-indigo-50 text-indigo-700',
  },
};

export const SETTINGS_SECTION_ALIASES = {
  'registers-barcode': 'catalog-product-barcodes',
  'purchase-order-notifications': 'notifications',
};

export const normalizeSettingsSectionId = (sectionId) => (
  SETTINGS_SECTION_ALIASES[sectionId] || sectionId
);

export const buildSettingsPath = (topicId, sectionId, search = '') => {
  const params = new URLSearchParams(search || '');
  params.delete('topic');
  params.delete('section');
  const query = params.toString();
  return `/settings/${topicId}/${sectionId}${query ? `?${query}` : ''}`;
};

export const getSettingsBranchIdFromSearch = (search = '') => {
  const value = String(new URLSearchParams(search || '').get('branchId') || '').trim();
  return /^\d+$/.test(value) && Number(value) > 0 ? value : '';
};

export const buildSettingsBranchSearch = (search = '', branchId = '') => {
  const params = new URLSearchParams(search || '');
  const normalizedBranchId = String(branchId || '').trim();
  if (/^\d+$/.test(normalizedBranchId) && Number(normalizedBranchId) > 0) {
    params.set('branchId', normalizedBranchId);
  } else {
    params.delete('branchId');
  }
  const query = params.toString();
  return query ? `?${query}` : '';
};

export const resolveSettingsBranchSelection = ({
  currentBranchId = '',
  branches = [],
  listResolved = false,
  canReadBranches = true,
  hasError = false,
} = {}) => {
  const current = String(currentBranchId || '');
  if (!listResolved || !canReadBranches || hasError) return current;
  const available = Array.isArray(branches) ? branches : [];
  if (!available.length) return '';
  if (available.some((branch) => String(branch.id) === current)) return current;
  return String(available[0].id);
};

export const getSettingsSectionAccess = (user) => {
  const canReadBranches = hasPermission(user, 'branch.read');
  const canReadTaxes = hasPermission(user, 'tax.read');
  const canReadUsers = hasPermission(user, 'user.read');
  const canReadProducts = hasPermission(user, 'product.read');
  const canReadPrices = hasPermission(user, 'price.read');
  const canReadCategories = hasAnyPermission(user, ['category.read', 'category.manage']);
  const canManagePurchaseOrderReasons = hasAnyPermission(user, [
    'purchase_order.settings',
    'purchase_order.settings.read',
    'settings.read',
  ]);
  const canManageClientPricing = hasAnyPermission(user, [
    'client_pricing.manage',
    'client_pricing.read',
    'settings.read',
  ]);
  const canManageGlobalSettings = hasAnyPermission(user, [
    'branch.access.any',
    'settings.read',
    'settings.manage',
  ]);
  const canReviewPurchaseOrders = hasAnyPermission(user, [
    'purchase_order.read',
    'purchase_order.update',
    'purchase_order.settings',
  ]);
  const canAccessRegisters = hasAnyPermission(user, [
    'cash_register.read',
    'cash_register.manage',
    'cash_register.assign_users',
  ]);
  const canConfigureRegisters = hasAnyPermission(user, [
    'cash_register.manage',
    'cash_register.assign_users',
  ]);
  const canUsePersonalPrintSettings = Boolean(user);

  return {
    companies: isSuperAdminUser(user),
    'sale-rounding': hasAnyPermission(user, ['settings.read', 'settings.manage']),
    'registers-printing': canUsePersonalPrintSettings,
    'purchase-order-review': canReviewPurchaseOrders,
    'branch-directory': canReadBranches,
    'branch-price-sync': canManageGlobalSettings,
    'branch-stock-requests': canManageGlobalSettings,
    'purchase-order-reasons': canManagePurchaseOrderReasons,
    'purchase-order-notifications': canManagePurchaseOrderReasons,
    notifications: canManagePurchaseOrderReasons,
    'purchase-order-visible-formats': canManageGlobalSettings,
    'purchase-order-default-categories': canManageGlobalSettings,
    'catalog-categories': canReadCategories,
    'catalog-subcategories': canReadCategories,
    'catalog-category-barcodes': canManageGlobalSettings,
    'catalog-price-list': canReadPrices,
    'complex-price-rules': canReadPrices,
    'catalog-product-formats': canManageGlobalSettings,
    'catalog-format-equivalences': canReadProducts,
    'catalog-product-barcodes': canUsePersonalPrintSettings,
    'catalog-product-search': canManageGlobalSettings,
    'catalog-pos-sales': canManageGlobalSettings,
    'catalog-price-recommendations': canReadPrices,
    'catalog-products': canReadProducts,
    'client-pricing-categories': canManageClientPricing,
    'client-pricing-configuration': canManageClientPricing,
    'taxes-manage': canReadTaxes,
    'users-access': canReadUsers,
    'registers-cash': canAccessRegisters,
    'registers-print-defaults': canManageGlobalSettings,
    'registers-barcode': canManageGlobalSettings,
    'price-auto-rule': canManageGlobalSettings,
    'registers-pos-favs': canAccessRegisters && canReadProducts,
  };
};

export const getVisibleSettingsTopics = (user) => {
  const sectionAccess = getSettingsSectionAccess(user);
  const productConfigurationSections = [];
  const visibleTopics = SETTINGS_TOPICS
    .map((topic) => ({
      ...topic,
      sections: topic.sections
        .filter((section) => sectionAccess[section.id] === true)
        .filter((section) => {
          if (!section.productConfiguration) return true;
          productConfigurationSections.push({
            ...section,
            group: topic.label,
            sourceTopicId: topic.id,
          });
          return false;
        }),
    }))
    .filter((topic) => topic.sections.length > 0);

  if (!productConfigurationSections.length) return visibleTopics;

  const productConfigurationTopic = {
    id: 'product-configuration',
    label: 'Configuraciones de producto',
    description: 'Configuraciones avanzadas de productos y operacion.',
    collapsible: true,
    sections: productConfigurationSections,
  };
  return [...visibleTopics, productConfigurationTopic];
};

export const findSettingsTopicBySection = (topics, sectionId) => {
  const normalizedSectionId = normalizeSettingsSectionId(sectionId);
  return (topics || []).find((topic) =>
    topic.sections.some((section) => section.id === normalizedSectionId)
  ) || null;
};

export const resolveSettingsDestination = ({
  visibleTopics,
  topicId,
  sectionId,
  search = '',
}) => {
  const topics = Array.isArray(visibleTopics) ? visibleTopics : [];
  if (!topics.length) return null;

  const params = new URLSearchParams(search || '');
  if ((sectionId || params.get('section')) === 'registers-cash') {
    params.set('configure', '1');
    params.set('focus', 'registers');
    params.delete('section');
    return resolveSettingsDestination({ visibleTopics, topicId: 'branches', sectionId: 'branch-directory', search: params.toString() });
  }
  const requestedTopicId = topicId || params.get('topic') || '';
  const requestedSectionId = normalizeSettingsSectionId(sectionId || params.get('section') || '');
  const requestedTopic = topics.find((topic) => topic.id === requestedTopicId) || null;
  const topicWithRequestedSection = requestedSectionId
    ? findSettingsTopicBySection(topics, requestedSectionId)
    : null;
  const requestedTopicHasSection = Boolean(
    requestedTopic?.sections.some((section) => section.id === requestedSectionId)
  );
  const topic = requestedTopicHasSection
    ? requestedTopic
    : topicWithRequestedSection || requestedTopic || topics[0];
  const section = topic.sections.find((entry) => entry.id === requestedSectionId) || topic.sections[0];

  return {
    topic,
    section,
    path: buildSettingsPath(topic.id, section.id, search),
  };
};
